import * as yup from 'yup';

import type { SalesCoverageUnderwriterEmployeeDetailFragment } from '../graphql/__generated__';

export type ContactInformationFormValues = {
  email1: string;
  email2: string;
  phoneNumber1: string;
  phoneNumber2: string;
  faxNumber1: string;
  faxNumber2: string;
  address1: string;
  address2: string;
};

export const contactInformationValidationSchema = yup.object({
  email1: yup.string().trim().email('Enter a valid primary email address'),
  email2: yup.string().trim().email('Enter a valid secondary email address').optional(),
  phoneNumber1: yup.string().trim(),
  phoneNumber2: yup.string().trim(),
  faxNumber1: yup.string().trim(),
  faxNumber2: yup.string().trim(),
  address1: yup.string().trim(),
  address2: yup.string().trim(),
});

export const getInitialContactInformationValues = (
  employee: SalesCoverageUnderwriterEmployeeDetailFragment
): ContactInformationFormValues => ({
  email1: employee.email1 ?? '',
  email2: employee.email2 ?? '',
  phoneNumber1: employee.phoneNumber1 ?? '',
  phoneNumber2: employee.phoneNumber2 ?? '',
  faxNumber1: employee.faxNumber1 ?? '',
  faxNumber2: employee.faxNumber2 ?? '',
  address1: employee.address1 ?? '',
  address2: employee.address2 ?? '',
});
